<template>
  <a href="#" class="link1" role="button" v-if="linkShow" @click.prevent="$emit('click')">{{props.linkText}}</a>
</template>

<script setup lang="ts">
const props = defineProps(['linkText', 'linkShow'])
const emit = defineEmits(['click'])
</script>


<style lang="scss" scoped>
.link1{
  display:inline-block;
  font-size:1.2rem;
  font-weight:700
}
</style>
